export default {
  'app.title': 'RustDesk コントロールパネル',
  'navBar.lang': '言語',
  'layout.user.link.help': 'ヘルプ',
  'layout.user.link.privacy': 'プライバシー',
  'layout.user.link.terms': '利用規約',
  'app.preview.down.block': 'このページをローカルプロジェクトにダウンロード',
  'app.welcome.link.fetch-blocks': 'すべてのブロックを取得',
  'app.welcome.link.block-list': 'ブロックに基づいて開発し、標準ページを迅速に構築',
  'The verification code is incorrect or has expired': '確認コードが間違っているか、期限切れです',
  'If an account exists, a verification code has been sent.': 'アカウントが存在する場合、確認コードを送信しました。',
  'Failed to get verification code': '確認コードの取得に失敗しました',
  Type: 'タイプ',
  Remote: 'リモート',
  remoteTip: 'リモートで制御されるコンピュータまたは他の端末',
  Local: 'ローカル',
  'Controlled Device': '被制御デバイス',
  'Controlling Side': '操作側',
  'Start Time': '開始時間',
  'End Time': '終了時間',
  Note: 'ノート',
  'Log List': 'ログリスト',
  'Device List': 'デバイスリスト',
  'User List': 'ユーザーリスト',
  'User Name': 'ユーザー名',
  'Controlling User': '操作ユーザー',
  'controller_user_search_tip': '被制御クライアントのバージョン >= 1.4.9 が必要です。',
  'Authentication Method': '認証方式',
  'Authentication': '認証',
  'authentication_column_tip': '形式: プライマリ認証 + 2FA。被制御クライアントのバージョン >= 1.4.9 が必要です。',
  'Primary Auth': 'プライマリ認証',
  'Auth Method': '認証方式',
  '2FA': '2FA',
  '2FA Code': '2FAコード',
  'Click Confirmation': 'クリック確認',
  'One-time Password': 'ワンタイムパスワード',
  'Permanent Password': '固定パスワード',
  'Switch Sides': '操作側を切り替え',
  'Trusted Device': '信頼済みデバイス',
  Updating: '更新中',
  Adding: '追加中',
  Deleting: '削除中',
  Create: '作成',
  Add: '追加',
  Confirm: '確認',
  Submit: '送信',
  Warning: '警告',
  Error: 'エラー',
  Email: 'メール',
  Status: 'ステータス',
  Action: 'アクション',
  Password: 'パスワード',
  'New Password': '新しいパスワード',
  Edit: '編集',
  Normal: '通常',
  Disabled: '無効',
  Disable: '無効',
  Enable: '有効',
  Chosen: '選択',
  Items: '項目',
  User: 'ユーザー',
  Info: '情報',
  'Log out': 'ログアウト',
  Settings: '設定',
  'Basic Settings': '基本設定',
  'Remote Desktop': 'リモートデスクトップ',
  'File Transfer': 'ファイル転送',
  'Port Transfer': 'ポート転送',
  'View Camera': 'カメラを表示',
  'Terminal': 'ターミナル',
  'Not Logged In': 'ログインしていません',
  'Created Time': '作成時間',
  Delete: '削除',
  Group: 'グループ',
  'Device Group': 'デバイスグループ',
  'User Group': 'ユーザーグループ',
  Name: '名前',
  'Group List': 'グループリスト',
  deleteConfirm: '削除してもよろしいですか？',
  groupTip: '同じグループのユーザーは相互にアクセスできます',
  document: 'ドキュメント',
  Detail: '詳細情報',
  Direction: '方向',
  File: 'ファイル',
  Directory: 'ディレクトリ',
  Disconnect: '切断',
  Time: '時間',
  'Export as csv': 'CSVとしてエクスポート',
  exportCsvTip: '一度に最大1000件の記録をエクスポート',
  'Not binded only': '未バインドデバイスのみ表示',
  Close: '閉じる',
  'Default Strategy': 'デフォルト戦略',
  'applied device num': '適用されたデバイス数',
  'Device Name': 'デバイス名',
  'Strategy': '戦略',
  'Device Strategy': 'デバイス戦略',
  'User Strategy': 'ユーザー戦略',
  'Group Strategy': 'グループ戦略',
  'strategy_tooltip': "フォーマット：\"デバイス戦略 / ユーザー戦略 / グループ戦略\"。単独で '-' を表示することはデフォルト戦略を使用することを意味し、特定の位置に '-' が表示されることはそのレベルで戦略が設定されていないことを意味します",
  Search: '検索',
  Select: '選択',
  Assign: '割り当て',
  Device: 'デバイス',
  'Device Username': 'デバイスユーザー名',
  Role: '役割',
  'Auth Type': '認証タイプ',
  Invite: '招待',
  'Please configure Email SMTP settings first': '最初にメールSMTP設定を構成してください',
  'Security Settings': 'セキュリティ設定',
  'Manage Signed Devices': '署名されたデバイスを管理',
  'Since 2FA is enabled, the email login verification option is not used. 2FA login verification will be used instead.': '2FAが有効になっているため、メールログイン確認オプションは使用されません。代わりに2FAログイン確認が使用されます。',
  'Enable alarm event email notification': 'アラームイベントのメール通知を有効にする',
  'Enable email login verification': 'メールログイン確認を有効にする',
  'License Type': 'ライセンスタイプ',
  'Renew / Upgrade License': 'ライセンスの更新 / アップグレード',
  Save: '保存',
  Back: '戻る',
  'Confirm Password': 'パスワードを確認',
  'username@device_name': 'ユーザー名@デバイス名',
  'Hide username': 'ユーザー名を隠す',
  'Remote device': 'リモートデバイス',
  'Within-group connections': 'グループ内接続',
  'Cross-group connections': 'グループ間接続',
  welcomeTitle: 'RustDeskへようこそ',
  Cancel: 'キャンセル',
  OK: 'OK',

  'pages.GroupList.User Group': 'ユーザーグループ',
  'pages.GroupList.User': 'ユーザー',

  'pages.CustomClient.Application name': 'アプリケーション名',
  'pages.CustomClient.Package name': 'パッケージ名',
  'pages.CustomClient.Bundle identifier': 'バンドル識別子',
  'pages.CustomClient.Server': 'サーバー',
  'pages.CustomClient.CPU Architecture': 'CPU アーキテクチャ',
  'pages.CustomClient.Distribution': 'ディストリビューション',
  'pages.CustomClient.Disable auto padding of application icon': 'アプリケーションアイコンの自動余白を無効化',
  'pages.CustomClient.Name': '名前',
  'pages.CustomClient.Build': 'ビルド',
  'pages.CustomClient.Note': 'ノート',
  'pages.CustomClient.Action': 'アクション',
  'pages.CustomClient.Delete': '削除',
  'pages.CustomClient.Edit': '編集',
  'pages.CustomClient.Duplicate': '複製',
  'pages.CustomClient.Create': '作成',
  'pages.CustomClient.Custom Clients': 'カスタムクライアント',
  'pages.CustomClient.General': '一般',
  'pages.CustomClient.Name of the configuration': '構成名',
  'pages.CustomClient.MSI installer': 'MSIインストーラー',
  'pages.CustomClient.Package format': 'パッケージ形式',
  'pages.CustomClient.Connection type': '接続タイプ',
  'pages.CustomClient.Bidirectional': '双方向',
  'pages.CustomClient.Incoming': '受信 (Incoming)',
  'pages.CustomClient.Outgoing': '送信 (Outgoing)',
  'pages.CustomClient.Options': 'オプション',
  'pages.CustomClient.Disable installation': 'インストールを無効にする',
  'pages.CustomClient.Disable settings': '設定を無効にする',
  'pages.CustomClient.Disable address book': 'アドレス帳を無効にする',
  'pages.CustomClient.Disable TCP listen port': 'TCPリッスンポートを無効にする',
  'pages.CustomClient.Disable user account': 'ユーザーアカウントを無効にする',
  'pages.CustomClient.Some note about this configuration': 'この構成に関する注意事項',
  'pages.CustomClient.Custom server': 'カスタムサーバー',
  'pages.CustomClient.Visual': 'ビジュアル',
  'pages.CustomClient.Application icon': 'アプリケーションアイコン',
  'pages.CustomClient.Security': 'セキュリティ',
  'pages.CustomClient.Preset password': 'プリセットパスワード',
  'pages.CustomClient.Advanced': '高度',
  'pages.CustomClient.Override settings': '設定を上書き',
  'pages.CustomClient.Default settings': 'デフォルト設定',
  'pages.CustomClient.Note: ': '注意：',
  'pages.CustomClient.Click or drag to upload': 'クリックまたはドラッグしてアップロード',
  'pages.CustomClient.app_icon_desc_tip': 'アプリケーションアイコンとして512x512ピクセルの正方形PNG画像をアップロードしてください。',
  'pages.CustomClient.app_name_desc_tip': '開始メニュー、コントロールパネルなどに表示される一意の名前を指定してください。',
  'pages.CustomClient.logo_desc_tip': 'カスタムクライアントのメインウィンドウの上部に表示されるPNG画像をアップロードしてください。サイズは自動的にスケーリングされます。200x40ピクセルのPNGを使用することをお勧めします。',
  'pages.CustomClient.Light Logo': 'ライトテーマのロゴ',
  'pages.CustomClient.Dark Logo': 'ダークテーマのロゴ',
  'pages.CustomClient.light_logo_desc_tip': 'ライトテーマ用のPNGロゴをアップロードしてください。サイズは自動的にスケーリングされます。200x40ピクセルのPNGを使用することをお勧めします。',
  'pages.CustomClient.dark_logo_desc_tip': 'ダークテーマ用のPNGロゴをアップロードしてください。サイズは自動的にスケーリングされます。200x40ピクセルのPNGを使用することをお勧めします。',
  'pages.CustomClient.This password will be used as a default permanent password for all new clients. It can be changed by the client.': 'このパスワードはすべての新しいクライアントのデフォルトの永久パスワードとして使用されます。クライアントによって変更できます。',
  'pages.CustomClient.Preset password is set.': 'プリセットパスワードは設定済みです。',
  'pages.CustomClient.Change password': 'パスワードを変更',
  'pages.CustomClient.Keep current password': '現在のパスワードを保持',
  'pages.CustomClient.The application icon must be a PNG file.': 'アプリケーションアイコンはPNGファイルでなければなりません。',
  'component.tagSelect.expand': '展開',
  'component.tagSelect.collapse': '折りたたむ',
  'component.tagSelect.all': 'すべて',
  'component.LicenseAlert.Your license is invalid.': 'ライセンスが無効です',
  'component.LicenseAlert.Your license is not set.': 'ライセンスが設定されていません',
  'component.LicenseAlert.Your license is about to expire in 2 weeks.': 'ライセンスは2週間以内に期限切れになります',
  'component.LicenseAlert.Your license has expired.': 'ライセンスが期限切れです',
  'pages.CustomClient.Refresh status manually': '手動でステータスを更新',
  'pages.CustomClient.the building task': 'ビルドタスク',
  'pages.CustomClient.Stop': '停止',
  'pages.CustomClient.Cancel': 'キャンセル',
  'pages.CustomClient.Completed at %s, this file will be deleted in 1 day.': '%sに完了しました。このファイルは1日後に削除されます。',
  'pages.CustomClient.artifactexpired': 'このビルドは24時間以上前のものです。アーティファクトは削除されました。再ビルドしてください。',

  'component.globalHeader.search': 'サイト内検索',
  'component.globalHeader.help': '使用ドキュメント',
  'component.globalHeader.notification': '通知',
  'component.globalHeader.notification.empty': 'すべての通知を確認しました',
  'component.globalHeader.message': 'メッセージ',
  'component.globalHeader.message.empty': 'すべてのメッセージを読みました',
  'component.globalHeader.event': 'タスク',
  'component.globalHeader.event.empty': 'すべてのタスクを完了しました',
  'component.noticeIcon.clear': 'クリア',
  'component.noticeIcon.cleared': 'クリアしました',
  'component.noticeIcon.empty': 'データはありません',
  'component.noticeIcon.view-more': 'もっと見る',
  'Token List': 'トークンリスト',
  Description: '説明',
  'Device Permission': 'デバイス権限',
  'Audit Log Permission': '監査ログ権限',
  'User Permission': 'ユーザー権限',
  'Group Permission': 'グループ権限',
  'Strategy Permission': '戦略権限',
  'Address Book Permission': 'アドレス帳権限',

  'menu.welcome': 'ようこそ',
  'menu.more-blocks': 'もっとブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理ページ',
  'menu.admin.sub-page': 'サブ管理ページ',
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.register-result': '登録結果',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析ページ',
  'menu.dashboard.monitor': 'モニターページ',
  'menu.dashboard.workplace': '作業場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォームページ',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（送金情報の入力）',
  'menu.form.step-form.confirm': 'ステップフォーム（送金情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完了）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リストページ',
  'menu.list.audit-list': 'セキュリティ監査',
  'menu.list.audit-list.Alarm': 'リスク/異常アラーム',
  'menu.list.audit-list.Connection': '接続ログ',
  'menu.list.audit-list.File': 'ファイル転送ログ',
  'menu.list.audit-list.Console': 'コンソール操作ログ',
  'menu.list.device-list': 'デバイス',
  'menu.list.user-list': 'ユーザー',
  'menu.list.group-list': 'グループ',
  'menu.list.group-list.user': 'ユーザーグループ',
  'menu.list.group-list.device': 'デバイスグループ',
  'menu.list.table-list': 'クエリテーブル',
  'menu.list.basic-list': '標準リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト（記事）',
  'menu.list.search-list.projects': '検索リスト（プロジェクト）',
  'menu.list.search-list.applications': '検索リスト（アプリケーション）',
  'menu.list.role-list': 'ロール',
  'menu.list.role-list.admin': '管理者ロール',
  'menu.list.role-list.control': 'コントロールロール',
  'menu.profile': '詳細ページ',
  'menu.profile.basic': '基本詳細ページ',
  'menu.profile.advanced': '高度な詳細ページ',
  'menu.result': '結果ページ',
  'menu.result.success': '成功ページ',
  'menu.result.fail': '失敗ページ',
  'menu.exception': '例外ページ',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'エラーをトリガー',
  'menu.account': '個人ページ',
  'menu.account.center': '個人センター',
  'menu.account.settings': '個人設定',
  'menu.account.trigger': 'エラーをトリガー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローチャートエディタ',
  'menu.editor.mind': 'マインドマップエディタ',
  'menu.editor.koni': 'トポロジーエディタ',
  'menu.Settings': '設定',
  'menu.Strategy': '戦略',
  'menu.Settings.Key': 'キー',
  'menu.Settings.License': 'ライセンス',
  'menu.Settings.Relay': '中継管理',
  'menu.Settings.Others': 'その他',
  'menu.Settings.Tokens': 'トークン',
  'menu.Address Books': 'アドレス帳',
  'menu.Strategies': '戦略',
  'menu.Custom Clients': 'カスタムクライアント',

  'pages.login.accountLogin.tab': 'アカウントパスワードログイン',
  'pages.login.accountLogin.errorMessage': '無効なユーザー名またはパスワード',
  'pages.login.failure': 'ログインに失敗しました。再試行してください！',
  'pages.login.success': 'ログイン成功！',
  'pages.login.username.placeholder': 'ユーザー名: admin または user',
  'pages.login.username.required': 'ユーザー名は必須項目です！',
  'pages.login.password.placeholder': 'パスワード: ant.design',
  'pages.login.password.required': 'パスワードは必須項目です！',
  'pages.login.phoneLogin.tab': '電話番号ログイン',
  'pages.login.phoneLogin.errorMessage': '確認コードが無効です',
  'pages.login.phoneNumber.placeholder': '電話番号を入力してください！',
  'pages.login.phoneNumber.required': '電話番号は必須項目です！',
  'pages.login.phoneNumber.invalid': '無効な電話番号です！',
  'pages.login.captcha.placeholder': '確認コードを入力してください！',
  'pages.login.captcha.required': '確認コードは必須項目です！',
  'pages.login.phoneLogin.getVerificationCode': '確認コードを取得',
  'pages.getCaptchaSecondText': '秒後に再取得',
  'pages.login.rememberMe': '自動ログイン',
  'pages.login.forgotPassword': 'パスワードを忘れましたか？',
  'pages.login.submit': 'ログイン',
  'pages.login.loginWith': '他のログイン方法:',
  'pages.login.loginWithGoogle': 'Googleでログイン',
  'pages.login.loginWithGithub': 'Githubでログイン',
  'pages.login.loginWithOkta': 'Oktaでログイン',
  'pages.login.loginWith.requesting_auth': '認証ページをリクエスト中',
  'pages.login.loginWith.waiting_auth': 'アカウント認証を完了してください',
  'pages.login.registerAccount': 'アカウントを登録',
  'pages.welcome.advancedComponent': '高度なテーブル',
  'pages.welcome.link': 'ようこそ',
  'pages.welcome.advancedLayout': '高度なレイアウト',
  'pages.welcome.alertMessage': 'より速く、より強力な重いコンポーネントがリリースされました。',
  'pages.account.tfaComponent.Enable 2FA': '2FAを有効にする',
  'pages.account.tfaComponent.2 Factor Authentication is enabled.': '二要素認証が有効になっています',
  'pages.account.tfaComponent.Your 2FA key has been in use for an extended period. We recommend updating your 2FA key to ensure maximum account security.': 'あなたの2FAキーは長期間使用されています。最大のアカウントセキュリティを確保するために、2FAキーを更新することをお勧めします。',
  'pages.account.tfaComponent.Enable 2 Factor Authentication.': '二要素認証を有効にする',
  'pages.account.tfa.The code must be 6, 8, 10 digits.': 'コードは6、8、10桁でなければなりません。',
  'pages.account.tfa.The code must be 6 or 8 digits.': 'コードは6または8桁でなければなりません。',
  'pages.admin.subPage.title': 'このページはadmin権限が必要です',
  'pages.admin.subPage.alertMessage': 'umi uiがリリースされました。npm run uiで体験を開始してください。',
  'pages.AuditList.FileAuditList.files': 'ファイル',
  'pages.AuditList.FileAuditList.pathTip': '制御デバイス上のパス',
  'pages.AuditList.FileAuditList.limitedTip': '最大10個のファイルを表示',
  'pages.AuditList.FileAuditList.exportFilename': 'ファイル転送ログ',
  'pages.AuditList.ConnAuditList.modal_title': '操作を確認',
  'pages.AuditList.ConnAuditList.diconnect_confirm_tip': '本当にこのデバイスを切断しますか？',
  'pages.AuditList.ConnAuditList.disconnect_succ': '切断成功！',
  'pages.AuditList.ConnAuditList.disconnect_fail': '切断失敗！',
  'pages.AuditList.ConnAuditList.exportFilename': '接続ログ',
  'pages.AuditList.AlarmAuditList.Login Device / Controlling Side': '送信元',
  'pages.AuditList.AlarmAuditList.Login Account / Controlled Device': '対象',
  'pages.AuditList.AlarmAuditList.From Tip': 'アカウント / ログインデバイス / 操作側',
  'pages.AuditList.AlarmAuditList.Target Tip': 'ログインアカウント / 被制御デバイス',
  'pages.AuditList.AlarmAuditList.Login Account': 'ログインアカウント',
  'pages.AuditList.AlarmAuditList.Login Account Search Tip': 'ログインアカウントタイプのアラームログでは、Login Account 検索は常にサポートされます。接続タイプのアラームログで操作側の Login Account を検索するには、被制御クライアントのバージョン >= 1.4.9 が必要です。',
  'pages.AuditList.AlarmAuditList.Device ID': 'デバイスID',
  'pages.AuditList.AlarmAuditList.Device Name': 'デバイスユーザー名',
  'pages.AuditList.AlarmAuditList.Controlled Device': '被制御デバイス',
  'pages.AuditList.AlarmAuditList.Event Time': '発生時間',
  'pages.AuditList.AlarmAuditList.IP whiltelist': 'ホワイトリスト外のIPがアクセスを試みました',
  'pages.AuditList.AlarmAuditList.ID whitelist': 'ホワイトリスト外のIDがアクセスを試みました',
  'pages.AuditList.AlarmAuditList.ExceedThirtyAccessAttempts': '30回以上のアクセス試行',
  'pages.AuditList.AlarmAuditList.MultipleAccessAttemptsWithinOneMinute': '1分以内に複数のアクセス試行',
  'pages.AuditList.AlarmAuditList.ExceedThirtyLoginAttempts': '30回以上のログイン試行',
  'pages.AuditList.AlarmAuditList.MultipleLoginsAttemptsWithinOneMinute': '1分以内に複数のログイン試行',
  'pages.AuditList.AlarmAuditList.MultipleLoginsAttemptsWithinOneHour': '1時間以内に複数のログイン試行',
  'pages.AuditList.AlarmAuditList.ExceedIPv6PrefixAttempts': '単一のIPv6プレフィックスからの連続したアクセス試行が多すぎます',
  'pages.AuditList.AlarmAuditList.TerminalOsLoginBackoff': 'ターミナル（管理者として実行）でログイン失敗が複数回発生（ユーザー名またはパスワードが正しくありません）',
  'pages.AuditList.AlarmAuditList.TerminalOsLoginConcurrency': '同時に複数のターミナル（管理者として実行）ログイン試行',
  'pages.AuditList.AlarmAuditList.SessionScopeViolation': 'セッションスコープ違反',
  'pages.AuditList.AlarmAuditList.exportFilename': 'リスク異常アラームログ',
  'pages.AuditList.ConsoleAuditList.Operation': '操作',
  'pages.AuditList.ConsoleAuditList.Name': '名前',
  'pages.AuditList.ConsoleAuditList.Name list': '名前リスト',
  'pages.AuditList.ConsoleAuditList.ID list': 'IDリスト',
  'pages.AuditList.ConsoleAuditList.Result': '結果',
  'pages.AuditList.ConsoleAuditList.Remote': 'リモート',
  'pages.AuditList.ConsoleAuditList.Local': 'ローカル',
  'pages.AuditList.ConsoleAuditList.User Login': 'ユーザーがコンソールにログイン',
  'pages.AuditList.ConsoleAuditList.Add Group': '新しいグループを作成',
  'pages.AuditList.ConsoleAuditList.Add User': 'ユーザーを追加',
  'pages.AuditList.ConsoleAuditList.Add Device': 'デバイスを追加',
  'pages.AuditList.ConsoleAuditList.Delete Groups': 'グループを一括削除',
  'pages.AuditList.ConsoleAuditList.Disconnect Device': 'デバイス接続を切断',
  'pages.AuditList.ConsoleAuditList.Enable Users': 'ユーザーを有効にする',
  'pages.AuditList.ConsoleAuditList.Disable Users': 'ユーザーを無効にする',
  'pages.AuditList.ConsoleAuditList.Enable Devices': 'デバイスを一括有効にする',
  'pages.AuditList.ConsoleAuditList.Disable Devices': 'デバイスを一括無効にする',
  'pages.AuditList.ConsoleAuditList.Update Group': 'グループを更新',
  'pages.AuditList.ConsoleAuditList.Update User': 'ユーザーを更新',
  'pages.AuditList.ConsoleAuditList.Update Device': 'デバイスを更新',
  'pages.AuditList.ConsoleAuditList.Delete User': 'ユーザーを削除',
  'pages.AuditList.ConsoleAuditList.Delete Device': 'デバイスを削除',
  'pages.AuditList.ConsoleAuditList.Add Address Book': 'アドレス帳を追加',
  'pages.AuditList.ConsoleAuditList.Delete Address Book': 'アドレス帳を削除',
  'pages.AuditList.ConsoleAuditList.Change Address Book Name': 'アドレス帳名を変更',
  'pages.AuditList.ConsoleAuditList.Group Management': 'グループ管理',
  'pages.AuditList.ConsoleAuditList.User Management': 'ユーザー管理',
  'pages.AuditList.ConsoleAuditList.Device Management': 'デバイス管理',
  'pages.AuditList.ConsoleAuditList.Address Book Management': 'アドレス帳管理',
  'pages.AuditList.ConsoleAuditList.exportFilename': 'コンソールログ',
  'pages.AuditList.ConsoleAuditList.Delete Devices in the Address Book Recycle Bin': 'アドレス帳のごみ箱からデバイスを削除',
  'pages.AuditList.ConsoleAuditList.Empty Address Book Recycle Bin': 'アドレス帳のごみ箱を空にする',
  'pages.AuditList.ConsoleAuditList.Add Address Book Permission': 'アドレス帳権限を追加',
  'pages.AuditList.ConsoleAuditList.Delete Address Book Permission': 'アドレス帳権限を削除',
  'pages.AuditList.ConsoleAuditList.Update Address Book Permission': 'アドレス帳権限を変更',
  'pages.Settings.Strategy.Strategy list': '戦略リスト',
  'pages.Settings.Strategy.Automatically close incoming sessions on user inactivity': 'ユーザーが非アクティブな場合、受信セッションを自動的に閉じる',
  'pages.Settings.Strategy.delete_strategy_tip': 'この戦略を削除してもよろしいですか？',
  'pages.Settings.Strategy.New strategy': '新しい戦略',
  'pages.Settings.Strategy.Rename strategy': '戦略の名前を変更',
  'pages.Settings.Strategy.Duplicate strategy': '戦略を複製',
  'pages.Settings.Strategy.Edit Devices': 'デバイスを編集',
  'pages.Settings.Strategy.Edit Users': 'ユーザーを編集',
  'pages.Settings.Strategy.Rename': '名前を変更',
  'pages.Settings.Strategy.Duplicate': '複製',
  'pages.Settings.Strategy.Delete': '削除',
  'pages.Settings.Strategy.Groups': 'グループ',
  'pages.Settings.Strategy.Select All': 'すべて選択',
  'pages.Settings.Strategy.Permissions': '権限',
  'pages.Settings.Strategy.Password': 'パスワード',
  'pages.Settings.Strategy.Security': 'セキュリティ',
  'pages.Settings.Strategy.Other': 'その他',
  'pages.Settings.Strategy.IP whitelist': 'IPホワイトリスト',
  'pages.Settings.Strategy.Cancel': 'キャンセル',
  'pages.Settings.Strategy.Submit': '確認',
  'pages.Settings.Strategy.Edit': '編集',
  'pages.Settings.Strategy.Custom': 'カスタム',
  'pages.Settings.Strategy.Full access': '完全アクセス',
  'pages.Settings.Strategy.Screen share': '画面共有のみ',
  'pages.Settings.Strategy.Enable keyboard/mouse': 'キーボード/マウスの制御を許可',
  'pages.Settings.Strategy.Enable remote printer': 'リモートプリンターの制御を許可',
  'pages.Settings.Strategy.Enable clipboard': 'クリップボードの同期を許可',
  'pages.Settings.Strategy.Enable file transfer': 'ファイル転送を許可',
  'pages.Settings.Strategy.Enable audio': '音声転送を許可',
  'pages.Settings.Strategy.Enable camera': 'カメラの表示を許可',
  'pages.Settings.Strategy.Enable terminal': 'ターミナルを許可',
  'pages.Settings.Strategy.Enable TCP tunneling': 'TCPトンネリングを許可',
  'pages.Settings.Strategy.Enable remote restart': 'リモート再起動を許可',
  'pages.Settings.Strategy.Enable recording session': 'セッションの録画を許可',
  'pages.Settings.Strategy.Enable blocking user input': 'ユーザー入力のブロックを許可',
  'pages.Settings.Strategy.Enable privacy mode': 'プライバシーモードを許可',
  'pages.Settings.Strategy.Enable remote configuration modification': 'リモート構成の変更を許可',
  'pages.Settings.Strategy.Permission type': '権限タイプ',
  'pages.Settings.Strategy.Approve mode': '認証方式',
  'pages.Settings.Strategy.Password type': 'パスワードタイプ',
  'pages.Settings.Strategy.Hide connection management window': '接続管理ウィンドウを隠す',
  'pages.Settings.Strategy.One-time password length': 'ワンタイムパスワードの長さ',
  'pages.Settings.Strategy.Numeric one-time password': '数字のワンタイムパスワード',
  'pages.Settings.Strategy.Accept sessions via password': 'パスワードによるアクセスのみを許可',
  'pages.Settings.Strategy.Accept sessions via click': 'クリックによるアクセスのみを許可',
  'pages.Settings.Strategy.Accept sessions via both': 'パスワードまたはクリックによるアクセスを許可',
  'pages.Settings.Strategy.Use one-time password': 'ワンタイムパスワードを使用',
  'pages.Settings.Strategy.Use permanent password': '固定パスワードを使用',
  'pages.Settings.Strategy.Use both passwords': '両方のパスワードを使用',
  'pages.Settings.Strategy.Deny LAN discovery': 'LAN発見を拒否',
  'pages.Settings.Strategy.Enable direct IP access': 'IP直接アクセスを許可',
  'pages.Settings.Strategy.auto_disconnect_option_tip': '非アクティブなセッションを自動的に閉じる',
  'pages.Settings.Strategy.deny_lan_discovery_desc_tip': 'デバイスは同じLAN内の他のデバイスに発見されません',
  'pages.Settings.Strategy.enable_direct_ip_access_desc_tip': 'デバイスへの直接IP接続を許可',
  'pages.Settings.Strategy.Remove wallpaper during incoming sessions': '受信セッション中にデスクトップの壁紙を削除',
  'pages.Settings.Strategy.minutes': '分',
  'pages.Settings.Strategy.Enable': '有効',
  'pages.Settings.Strategy.Disable': '無効',
  'pages.Settings.Strategy.disabled': '無効',
  'pages.Settings.Strategy.Default': 'デフォルト戦略',
  'pages.Settings.Strategy.Apply changes of this page': 'このページの変更を適用',
  'pages.Settings.Strategy.Invalid IP': '無効なIP',
  'pages.Settings.Strategy.IP Whitelisting': 'IPホワイトリスト',
  'pages.Settings.Strategy.Clear': 'クリア',
  'pages.Settings.Strategy.OK': '確認',
  'pages.Settings.Strategy.whitelist_sep': 'カンマ、セミコロン、スペース、または改行を区切り文字として使用できます',
  'pages.Settings.Strategy.Use IP whitelisting': 'ホワイトリスト上のIPのみアクセスを許可',
  'pages.Settings.Strategy.whitelist_tip': 'ホワイトリスト内のIPのみがこのマシンにアクセスできます',
  'pages.Settings.Strategy.whitelist_cidr_tip': 'CIDR 表記に対応しています。例: 192.168.1.0/24',
  'pages.Settings.Strategy.Invalid ID': '無効な ID',
  'pages.Settings.Strategy.ID whitelisting': 'ID ホワイトリスト',
  'pages.Settings.Strategy.Use ID whitelisting': 'ホワイトリスト上の ID のみアクセスを許可',
  'pages.Settings.Strategy.id_whitelist_tip': 'ホワイトリスト内の ID のみがこのマシンにアクセスできます',
  'pages.Settings.Strategy.id_whitelist_wildcard_tip': "ワイルドカードが使用できます。'*' は任意の数の文字、'?' はちょうど1文字に一致します",
  'pages.Settings.Strategy.id_whitelist_caveat_tip': 'ID は接続するクライアントから申告されます。ホワイトリストは露出を減らすもので、パスワードや 2FA の代わりにはなりません',
  'pages.CustomClient.bidirectional_desc_tip': '他のデバイスに接続でき、接続要求を受け取ることができるクライアントを作成します',
  'pages.CustomClient.incoming_desc_tip': '接続要求のみを受け取ることができるクライアントを作成します',
  'pages.CustomClient.outgoing_desc_tip': '他のデバイスに接続できるクライアントを作成します',
  'pages.CustomClient.disable_installation_desc_tip': 'カスタムクライアントのインストールを禁止します（Windowsのみ）',
  'pages.CustomClient.disable_settings_desc_tip': 'ユーザーがカスタムクライアントの設定にアクセスするのを無効にします',
  'pages.CustomClient.disable_ab_desc_tip': 'カスタムクライアント内のアドレス帳機能を無効にします',
  'pages.CustomClient.disable_tcp_desc_tip': 'RustDesk起動時にWindowsファイアウォールのダイアログを回避し、P2P直接接続の試行をスキップして中継接続を使用します',
  'pages.CustomClient.disable_account_desc_tip': 'RustDeskクライアント内でのユーザーログイン機能を削除します',
  'pages.CustomClient.override_settings_desc_tip': '設定を上書きし、RustDesk内で変更できなくします',
  'pages.CustomClient.default_settings_desc_tip': 'RustDeskがデフォルトで使用する設定を変更します',
  'pages.Settings.KeyPage.failedToFetchKey': 'キーの取得に失敗しました。',
  'pages.Settings.KeyPage.keyResetSuccess': 'キーのリセットに成功しました。変更を有効にするにはhbbrを再起動してください。',
  'pages.Settings.KeyPage.errorResettingKey': 'キーのリセット中にエラーが発生しました。',
  'pages.Settings.KeyPage.keyUpdateSuccess': 'キーの更新に成功しました。変更を有効にするにはhbbrを再起動してください。',
  'pages.Settings.KeyPage.errorUpdatingKey': 'キーの更新中にエラーが発生しました。キーを確認してください',
  'pages.Settings.KeyPage.key': 'キー',
  'pages.Settings.KeyPage.privateKey': '秘密鍵',
  'pages.Settings.KeyPage.publicKey': '公開鍵',
  'pages.Settings.KeyPage.editKey': 'キーを更新',
  'pages.Settings.KeyPage.reset': 'リセット',
  'pages.Settings.KeyPage.custom': '手動入力',
  'pages.Settings.KeyPage.pleaseInputPrivateKey': '秘密鍵を入力してください！',
  'pages.Settings.License.settingsUpdatedSuccess': '設定が正常に更新されました。',
  'pages.Settings.License.licenseCannotBeEmpty': 'ライセンスは空にできません。',
  'pages.Settings.License.license': 'ライセンス',
  'pages.Settings.Relay.GeoOverrideDescription': '複数の中継サーバーが存在する場合にのみ、位置オーバーライド機能を使用できます。',
  'pages.Settings.GeoOverride.ipOrDomain': 'IP/ドメイン',
  'pages.Settings.GeoOverride.latitude': '緯度',
  'pages.Settings.GeoOverride.longitude': '経度',
  'pages.Settings.GeoOverride.deleteSelectedConfirm': '選択した位置オーバーライドを削除してもよろしいですか？',
  'pages.Settings.GeoOverride.deleteConfirm': 'この位置オーバーライドを削除してもよろしいですか？',
  'pages.Settings.GeoOverride.editGeoOverride': 'オーバーライドを編集',
  'pages.Settings.GeoOverride.addGeoOverride': 'オーバーライドを追加',
  'pages.Settings.GeoOverride.ipOrDomainRequired': 'IP/ドメインは必須です。',
  'pages.Settings.GeoOverride.latitudeRequired': '緯度は必須です。',
  'pages.Settings.GeoOverride.longitudeRequired': '経度は必須です。',
  'pages.Settings.GeoOverride.testGeo': '位置をテスト',
  'pages.Settings.GeoOverride.geofileFetchFailed': 'GeoFile情報の取得に失敗しました。',
  'pages.Settings.GeoOverride.loadGeoOverrides': 'オーバーライドを読み込む',
  'pages.Settings.GeoOverride.geoOverride': '位置オーバーライド',
  'pages.Settings.GeoOverride.title': '位置オーバーライド',
  'pages.Settings.GeoOverride.RelaySettings': '設定',
  'pages.Settings.GeoOverride.RelayServers': '中継サーバー',
  'pages.Settings.GeoOverride.AddServer': 'サーバーを追加',
  'pages.Settings.GeoOverride.AlwaysUseRelay': '常に中継を使用',
  'pages.Settings.GeoOverride.UpdateServers': 'インポート修正',
  'pages.Settings.GeoOverride.UpdatedAlwaysUseRelay': '常に中継を使用が更新されました',
  'pages.Settings.GeoOverride.FailedToUpdateAlwaysUseRelay': '常に中継を使用の更新に失敗しました',
  'pages.Settings.GeoOverride.UpdatedRelayServers': '中継サーバーが更新されました',
  'pages.Settings.GeoOverride.FailedToUpdateRelayServers': '中継サーバーの更新に失敗しました',
  'pages.Settings.GeoOverride.UpdatedChangeIDSetting': '変更ID設定が更新されました',
  'pages.Settings.GeoOverride.FailedToUpdateChangeIDSetting': '変更ID設定の更新に失敗しました',
  "pages.Settings.Others.Allow change ID": "IDの変更を許可",
  "pages.Settings.Others.Disable new devices": "新しいデバイスを無効にする",
  "pages.Settings.Others.Require deployment for new devices": "新しいデバイスにデプロイを必須にする",
  "pages.Settings.Others.deployment_required_tip": "有効にすると、新しいデバイスはこのサーバーに登録するために `rustdesk --deploy --token <api_token>` を実行する必要があります。",
  "pages.Settings.Others.enable_switch_sides_bypass_acl": "サイド切り替えでアクセス制御をバイパスすることを許可",
  "pages.Settings.Others.enable_switch_sides_bypass_acl_tip": "このオプションはサイド切り替え機能自体の有効/無効を切り替えるものではありません。逆方向の接続が既に許可されている場合（例：アクセス制御ルールで制限されていない場合）、サイド切り替えは常に動作します。このオプションは、アクセス制御ルール（どのユーザー/グループがどのデバイスに接続できるかの規則）が逆方向をブロックする場合にのみ、切り替え後の接続がアクセス制御をバイパスすることを許可します。既定では無効です。",
  "pages.Settings.Others.Login is required on the control end before access": "制御側は接続前にログインする必要があります",
  "pages.Settings.Others.access_require_login_license_tip": "同時接続数が制限されたライセンスでは常に必要です",
  "pages.Settings.Others.Only admin can access unassigned devices": "管理者のみが未割り当てデバイスにアクセスできます",
  "pages.Settings.Others.Allow non-admin to share address books to other groups": "非管理者が他のグループとアドレス帳を共有できるようにする",
  'pages.Settings.OIDC.Maximum Number of Authorized Users': '最大認証ユーザー数',
  'pages.Settings.OIDC.emptyPrompt': '現在、サードパーティの認証プロバイダーはありません。使用するには追加してください。',
  'pages.Settings.OIDC.confirm-delete-title': '削除を確認',
  'pages.Settings.OIDC.confirm-delete-content': '関連するサードパーティの認証ユーザーは再度ログインできなくなります。これらのユーザーを削除するには、ユーザー管理インターフェースに移動できます。',
  'pages.Settings.OIDC.Trusted Origins': '信頼済みオリジン',
  'pages.Settings.OIDC.Add Trusted Origin': '信頼済みオリジンを追加',
  'pages.Settings.OIDC.invalid_trusted_origin': 'パス、クエリ、フラグメント、認証情報を含まない HTTP(S) オリジンを入力してください。',
  'pages.Settings.OIDC.insecure_http_origins_warning': 'HTTP の信頼済みオリジンは暗号化されていない接続を使用します。ローカル以外のオリジンには HTTPS を使用してください。',
  'pages.Settings.OIDC.trusted_origins_tip': 'Web コンソールを社内用と公開用の別々の FQDN など、複数のオリジンから利用する場合に設定します。許可する各オリジンには、スキーム、ホスト、必要に応じてポートのみを入力してください。空のままにすると、従来の単一オリジン動作が維持されます。管理下にあるオリジンのみを信頼し、対応する各コールバック URI を ID プロバイダーに登録してください。',
  'pages.Settings.OIDC.Use Avatar': 'アバターを使用',
  'pages.Settings.OIDC.use_avatar_tip': '新規ユーザー作成時にアバターを同期します。',
  'pages.Settings.OIDC.oidc_map_groups_tooltip': 'グループマッピングが有効になっている場合、ユーザーは最初のログイン時に対応するユーザーグループに追加されます。その後のログインでは、ユーザーグループは更新されません。ユーザーが複数のグループに属している場合、そのうちの1つにのみ追加されます。',
  'pages.Settings.Others.Only admin can access logs': '管理者のみが未割り当てのログにアクセスできます',
  'pages.Welcome.Max Devices': '最大デバイス数',
  'pages.Welcome.Max Users': '最大ユーザー数',
  'pages.Welcome.Not set': '未設定',
  'pages.Welcome.Invalid': '無効',
  'pages.Welcome.Demo': 'デモ',
  'pages.Welcome.Personal': '個人',
  'pages.Welcome.Business': 'ビジネス',
  'pages.Welcome.Unknown': 'その他',
  'pages.Welcome.Max Peers': '最大デバイス数',
  'pages.Welcome.RustDesk Server Status': 'RustDeskサーバーの状態',
  'pages.Welcome.Concurrent Connections': '同時接続数',
  'pages.Welcome.License Expire Time': 'ライセンスの有効期限',
  'pages.Welcome.Document': 'ドキュメント',
  'pages.Welcome.Config': '設定',
  'pages.Welcome.Windows EXE': 'Windows EXE',
  'pages.Welcome.Mobile QR Code': 'モバイル QR コード',
  'pages.AddressBook.Permission': '権限',
  'pages.AddressBook.Device count': 'デバイス数',
  'pages.AddressBook.Address Books': 'アドレス帳',
  'pages.AddressBook.Tags': 'タグ',
  'pages.AddressBook.Devices': 'デバイス',
  'pages.AddressBook.Device': 'デバイス',
  'pages.AddressBook.Alias': 'エイリアス',
  'pages.AddressBook.Whether a password is set': 'パスワードが設定されているか',
  'pages.AddressBook.Recycle Bin': 'ごみ箱',
  'pages.AddressBook.Empty Recycle Bin': 'ごみ箱を空にする',
  'pages.AddressBook.Personal': '個人',
  'pages.AddressBook.Personal (My address book)': '個人（私のアドレス帳）',
  'pages.AddressBook.Shared': '共有',
  'pages.AddressBook.Share': '共有',
  'pages.AddressBook.Delete': '削除',
  'pages.AddressBook.Settings': '設定',
  'pages.AddressBook.Owner': '所有者',
  'pages.AddressBook.My Permission': '私の権限',
  'pages.AddressBook.Read-only': '読み取り専用',
  'pages.AddressBook.Read/Write': '読み書き',
  'pages.AddressBook.Full Control': '完全制御',
  'pages.AddressBook.share_warning_tip': '上記のフィールドは共有され、他の人に見えることがあります。',
  'pages.AddressBook.permission_tip': '読み取り専用：デバイスとタグを表示できます；読み書き：デバイスとタグを編集できます；完全制御：再共有、削除、またはアドレス帳の名前を変更できます。',
  'pages.AddressBook.rule_priority_tip': '優先順位: ユーザー > グループ > すべての人',
  'Remove password': 'パスワードを削除',
  'pages.AddressBook.Import': 'インポート',
  'pages.AddressBook.Filter by intersection': '交差でフィルタリング',
  'pages.AddressBook.Permissions': '権限',
  'pages.AddressBook.Type': 'タイプ',
  'pages.AddressBook.Untagged': 'タグなし',

  'app.pwa.offline': '現在オフラインです',
  'app.pwa.serviceworker.updated': '新しいコンテンツがあります',
  'app.pwa.serviceworker.updated.hint': '「更新」ボタンをクリックするか、手動でページを更新してください',
  'app.pwa.serviceworker.updated.ok': '更新',

  'app.setting.pagestyle': '全体スタイル設定',
  'app.setting.pagestyle.dark': 'ダークメニュースタイル',
  'app.setting.pagestyle.light': 'ライトメニュースタイル',
  'app.setting.content-width': 'コンテンツ領域の幅',
  'app.setting.content-width.fixed': '固定幅',
  'app.setting.content-width.fluid': '流動的',
  'app.setting.themecolor': 'テーマカラー',
  'app.setting.themecolor.dust': '薄暮',
  'app.setting.themecolor.volcano': '火山',
  'app.setting.themecolor.sunset': '日暮れ',
  'app.setting.themecolor.cyan': '明青',
  'app.setting.themecolor.green': '極光緑',
  'app.setting.themecolor.daybreak': 'デイブレイクブルー（デフォルト）',
  'app.setting.themecolor.geekblue': '極客青',
  'app.setting.themecolor.purple': '紫',
  'app.setting.navigationmode': 'ナビゲーションモード',
  'app.setting.sidemenu': 'サイドメニューのレイアウト',
  'app.setting.topmenu': 'トップメニューのレイアウト',
  'app.setting.fixedheader': '固定ヘッダー',
  'app.setting.fixedsidebar': '固定サイドメニュー',
  'app.setting.fixedsidebar.hint': 'サイドメニューのレイアウト時に設定可能',
  'app.setting.hideheader': 'スクロール時にヘッダーを隠す',
  'app.setting.hideheader.hint': '固定ヘッダー時に設定可能',
  'app.setting.othersettings': 'その他の設定',
  'app.setting.weakmode': '色弱モード',
  'app.setting.copy': '設定をコピー',
  'app.setting.copyinfo': 'コピー成功。config/defaultSettings.jsでデフォルト設定を置き換えてください',
  'app.setting.production.hint':
    '設定バーは開発環境でのみプレビュー用であり、製品環境では表示されません。手動で設定ファイルを変更してください',

  'app.settings.menuMap.basic': '基本設定',
  'app.settings.menuMap.security': 'セキュリティ設定',
  'app.settings.menuMap.binding': 'アカウントバインディング',
  'app.settings.menuMap.notification': '新着通知',
  'app.settings.basic.avatar': 'アバター',
  'app.settings.basic.change-avatar': 'アバターを変更',
  'app.settings.basic.email': 'メール',
  'app.settings.basic.email-message': 'メールアドレスを入力してください！',
  'app.settings.basic.nickname': 'ニックネーム',
  'app.settings.basic.nickname-message': 'ニックネームを入力してください！',
  'app.settings.basic.profile': '自己紹介',
  'app.settings.basic.profile-message': '自己紹介を入力してください！',
  'app.settings.basic.profile-placeholder': '自己紹介',
  'app.settings.basic.country': '国/地域',
  'app.settings.basic.country-message': '国または地域を入力してください！',
  'app.settings.basic.geographic': '所在省市',
  'app.settings.basic.geographic-message': '所在省市を入力してください！',
  'app.settings.basic.address': '街道住所',
  'app.settings.basic.address-message': '街道住所を入力してください！',
  'app.settings.basic.phone': '連絡先電話番号',
  'app.settings.basic.phone-message': '連絡先電話番号を入力してください！',
  'app.settings.basic.update': '基本情報を更新',
  'app.settings.security.strong': '強',
  'app.settings.security.medium': '中',
  'app.settings.security.weak': '弱',
  'app.settings.security.password': 'アカウントパスワード',
  'app.settings.security.password-description': '現在のパスワードの強度',
  'app.settings.security.phone': 'セキュリティ携帯電話',
  'app.settings.security.phone-description': 'バインドされた携帯電話',
  'app.settings.security.question': 'セキュリティ質問',
  'app.settings.security.question-description': 'セキュリティ質問が設定されていません。セキュリティ質問はアカウントの安全を効果的に保護します',
  'app.settings.security.email': '予備メール',
  'app.settings.security.email-description': 'バインドされたメール',
  'app.settings.security.mfa': 'MFAデバイス',
  'app.settings.security.mfa-description': 'MFAデバイスがバインドされていません。バインド後、二次確認ができます',
  'app.settings.security.modify': '変更',
  'app.settings.security.set': '設定',
  'app.settings.security.bind': 'バインド',
  'app.settings.binding.taobao': 'タオバオをバインド',
  'app.settings.binding.taobao-description': '現在タオバオアカウントはバインドされていません',
  'app.settings.binding.alipay': 'アリペイをバインド',
  'app.settings.binding.alipay-description': '現在アリペイアカウントはバインドされていません',
  'app.settings.binding.dingding': 'ディンディンをバインド',
  'app.settings.binding.dingding-description': '現在ディンディンアカウントはバインドされていません',
  'app.settings.binding.bind': 'バインド',
  'app.settings.notification.password': 'アカウントパスワード',
  'app.settings.notification.password-description': '他のユーザーのメッセージはサイト内メッセージで通知されます',
  'app.settings.notification.messages': 'システムメッセージ',
  'app.settings.notification.messages-description': 'システムメッセージはサイト内メッセージで通知されます',
  'app.settings.notification.todo': 'タスク',
  'app.settings.notification.todo-description': 'タスクはサイト内メッセージで通知されます',
  'app.settings.open': '開',
  'app.settings.close': '閉',
  'app.copyright.produced': 'Purslane Tech Pte. Ltd. によって開発されました',
  'pages.account.Settings.Security.Password': 'パスワード',
  'pages.account.Settings.Security.Change password': 'パスワードを変更',
  'pages.account.tfa.Enable 2FA': '2FAを有効にする',
  'pages.account.tfa.2 Factor Authentication is enabled.': '二要素認証が有効になっています',
  'pages.account.tfa.Your 2FA key has been in use for an extended period. We recommend updating your 2FA key to ensure maximum account security.': 'あなたの2FAキーは長期間使用されています。最大のアカウントセキュリティを確保するために、2FAキーを更新することをお勧めします。',
  'pages.account.tfa.Enable 2 Factor Authentication.': '二要素認証を有効にする',

  'Enable Two-Factor Authentication': '二要素認証を有効にする',
  'Make your RustDesk account more secure by requiring an extra authentication code when you log in.': 'ログイン時に追加の認証コードを要求することで、RustDeskアカウントをより安全にします。',
  '1. Download an authenticator app': '1. 認証アプリをダウンロード',
  'Download an authenticator app such as': 'Google AuthenticatorやAuthyなどの認証アプリをダウンロード',
  '2FA code': '2FAコード',
  'Authenticator': '認証器',
  'on your phone or desktop.': 'あなたの電話またはデスクトップで。',
  '2. Scan the QR code': '2. QRコードをスキャン',
  'Open your authenticator app, scan the QR code and enter the code that your app shows.': '認証アプリを開き、QRコードをスキャンして、アプリが表示するコードを入力します。',
  'You can change or remove 2FA at any time in your account settings.': 'アカウント設定でいつでも2FAを変更または削除できます。',
  'Please verify your 2FA code to disable current 2FA first.': '現在の2FAを無効にする前に、2FAコードを確認してください。',
  'Can\'t verify the code. Check that code and local time settings are correct!': 'コードを確認できません。コードとローカル時間設定が正しいか確認してください！',
  'First sign-in:': '最初のサインイン：',
  'Recent activity:': '最近の活動：',
  'pages.Settings.GeoOverride.reloadGeo': '地理位置データを再読み込み',
  'pages.Settings.GeoOverride.getRelayServer': '中継サーバーを取得',
  'pages.Settings.GeoOverride.relayServer': '中継サーバー',
  'SMTP Host': 'SMTPホスト',
  'SMTP Port': 'SMTPポート',
  'My Server Requires Authentication': '私のサーバーは認証が必要です',
  'smtp.From': '送信者',
  'Mail Account': 'メールアカウント',
  'Mail Password': 'メールパスワード',
  'Client secrets have an expiration date. Set a calendar reminder before it expires to avoid service interruption.':
    'クライアントシークレットには有効期限があります。サービス中断を避けるため、期限切れ前にカレンダーリマインダーを設定してください。',
  'Custom Certificate PEM File Path (on the server)': 'カスタム証明書PEMファイルパス（サーバー上）',
  'Timeout (Seconds)': 'タイムアウト（秒）',
  Update: '更新',
  'Submit and Test Email': 'メールを送信してテスト',
  'he Receiver Email': '受信者メール',
  'LDAP Host': 'LDAPホスト',
  'LDAP Port': 'LDAPポート',
  'Filter': 'フィルター',
  'Username Attribute': 'ユーザー名属性',
  'The attribute used as the username when logging in. Default is "dn".': 'ログイン時にユーザー名として使用される属性。デフォルトは「dn」です。',
  'DraggableTab.Drag tab to reorder': 'タブをドラッグして順序を変更',
  'pages.Settings.OIDC.new.Auth Type': '認証タイプ',
  'pages.Settings.OIDC.New Auth Provider': '新しい認証プロバイダー',
  'pages.Settings.OIDC.new.New Auth Provider': '新しい認証プロバイダー',
  'pages.Settings.OIDC.Delete This Provider': 'このプロバイダーを削除',
  'pages.Settings.OIDC.new.Enable PKCE': 'PKCEを有効にする',
  'pages.Settings.OIDC.Enable PKCE': 'PKCEを有効にする',
  'pages.Settings.OIDC.new.Timeout(seconds) to force a refresh of metadata(e.g. JWKS) from OIDC providers': 'OIDCプロバイダーからメタデータ（例：JWKS）を強制的に更新するためのタイムアウト（秒）',
  'pages.Settings.OIDC.new.0 means no timeout, empty means default (3600)': '0はタイムアウトなし、空はデフォルト（3600）を意味します',
  'Callback URL': 'コールバックURL',
  'pages.Settings.Others.Session expiration time': 'セッションの有効期限',
  'pages.Settings.Others.Session expiration time tip': '変更しても、すでにログインしているセッションがすぐに短くなったり延長されたりすることはありません。今後のログインに適用され、既存のセッションは現在の期限に従います。',
  'pages.Settings.Others.Session expiration time (Days)': 'セッションの有効期限（日）',
  'pages.Settings.Others.Session expiration mode': 'セッション有効期限モード',
  'pages.Settings.Others.Since recent activity': '最近のアクティビティから',
  'pages.Settings.Others.Since login': 'ログインから',
  'pages.Settings.Others.2FA Issuer Name': '2FA 発行者名',
  'pages.Settings.Others.tfa_issuer_tip': '2FA QRコードをスキャンする際に認証アプリに「<名前> Login」として表示されます。デフォルトは RustDesk です。',
  'pages.Settings.Others.idp_allow_local_password_login': 'IdP（OIDC）ユーザーがローカルパスワードでログインすることを許可',
  'Or': 'または',
  'transfer_address_book': 'アドレス帳の転送',
  'transfer_address_book_confirm': 'このアドレス帳を転送してもよろしいですか？',
  'add_devices': 'デバイスを追加',
  'add_users': 'ユーザーを追加',
  'move_to': '移動先',
  'Username': 'ユーザー名',
  'audit_retention_days': 'ログの保持期間（日）',
  'audit_retention_days_tip': '0を入力すると、すべてのログを無期限に保存できます。指定された日数より古いログは自動的に削除されます。Cleanupは1時間に1回実行されます。',
  "set_password": "パスワードを設定",
  'disable_read_accessible': 'アクセス可能なデバイスの取得を無効化',
  'disable_read_accessible_tip': '有効にすると、RustDeskクライアントはアクセス可能なデバイスを取得できなくなります。',
  'default_shared_password': 'デフォルトの共有パスワード',
  'default_shared_password_tip': 'アドレス帳レベルの共有パスワード: このアドレス帳のデバイスに共有パスワードが設定されていない場合、このパスワードが共有パスワードとして使用されます。',
  'used_user': 'ライセンスユーザー（現在/最大）',
  'used_device': 'ライセンスデバイス（現在/最大）',
  'days': '日',
  'hours': '時間',
  'minutes': '分',
  'just now': 'たった今',
  'Offline': 'オフライン',
  'Online': 'オンライン',
  'last_online_sort_tip': 'オンラインソートは、フィルタリング後のデバイス数が%s以下の場合のみ利用できます。',
  'last_online': '最終オンライン時間',
  'OS': 'OS',
  'batch_delete_device_tooltip': '無効化されたオフラインのデバイスのみをバッチ削除できます。確認ダイアログのIDは、最後に選択されたデバイスのIDです。',
  'batch_delete_device_tooltip_deployment': '無効化されたデバイスのみをバッチ削除できます（デプロイモードではオンラインデバイスの削除が許可されます）。確認ダイアログのIDは、最後に選択されたデバイスのIDです。',
  'More': 'その他',
  'login_verification': 'ログイン認証',
  'reset_2fa': '2FAをリセット',
  'disable_email_login_verification': 'メール認証を無効化',
  'reset_2fa_confirm': '選択したユーザーの2FAをリセットしますか？',
  'disable_email_login_verification_confirm': '選択したユーザーのメール認証を無効化しますか？',
  'login_verification_column_tip': '2FAとメールの両方が設定されている場合、2FAのみが使用されます',
  'reset_2fa_tip': 'ユーザーのメール（設定されている場合）に通知が送信されます。リセット後、2FAが強制されている場合は次回ログイン時に再設定が必要です。強制されていない場合は2FA認証は不要です。',
  'disable_email_login_verification_tip': 'ユーザーのメールに通知が送信されます。無効化後は次回ログイン時にメール認証は不要です。',
  'disable_in_account_setting_tip': 'アカウント設定で自身のログイン認証を無効化してください。',
  'enable_2fa_enforcement': '2FA強制を有効化',
  'disable_2fa_enforcement': '2FA強制を無効化',
  'enable_2fa_enforcement_confirm': '2FAログインを強制しますか？',
  'disable_2fa_enforcement_confirm': '2FA強制を無効化しますか？',
  '2fa_enforcement_enable_tip': 'ユーザーのメール（設定されている場合）に通知が送信されます。強制後、次回ログイン時に2FAを設定するまでサインインできません。',
  '2fa_enforcement_disable_tip': 'ユーザーのメール（設定されている場合）に通知が送信されます。2FA強制を無効化しても、2FAは引き続き使用可能ですが必須ではありません。',
  'enforce_2fa_alert': '管理者が二要素認証の設定を要求しています。',
  'backup_codes_desc': '二要素認証を失った場合、バックアップコードを使用できます。安全な場所に保管してください。',
  'setup_2fa_success_alert': '2FAが正常に設定されました。バックアップコードをダウンロードしてログインに戻ってください。',
  '2fa_activation_status': '2FA 有効化ステータス',
  '2fa_enforcement_status': '2FA 強制ステータス',
  '2fa_enforced_and_active': '2FA が強制され、有効です',
  '2fa_enforced_but_pending': '2FA が強制されていますが、ユーザーによる設定が保留中です',
  '2fa_not_enforced_but_active': '2FA は強制されていませんが、有効です',
  'force_logout': 'ログアウト',
  'force_logout_tip': '選択したユーザーを全デバイスからログアウトさせます。',
  'force_logout_current_session_tip': '現在のセッションはログアウトされません。',
  'new_user_enforce_tfa': '新規ユーザーに2FA強制',
  'new_user_enforce_tfa_tip': '有効化時、新規ユーザーは初回ログイン時に2FAを設定する必要があります。',
  'confirm_disable_2fa_title': '2FA無効化確認',
  'confirm_disable_2fa_tip': 'アカウントは2FAが必須です。無効化すると次回ログイン時に再設定が必要です。続行しますか？',
  'reset_password': 'パスワードをリセット',
  'assign_devices': 'デバイスを割り当て',
  'email_login_verification_enabled': 'メール認証が有効になっています',
  'user_status': 'ユーザーステータス',
  'user_status_active': 'ユーザーは有効です。',
  'user_status_disabled': 'ユーザーは無効です。',
  'user_status_pending': '招待を送信しました。ユーザーの承諾を待っています。',
  'resend_invitation': 'ユーザーは招待を承諾していません。再送信できます。',
  'email_login_verification_status': 'メール認証ステータス',
  'set_tags': 'タグを設定',
  'set_note': 'メモを設定',
  'remove_all_tags': 'すべてのタグを削除',
  'no_tags_available': '利用可能なタグがありません',
  'remove_note': 'メモを削除',
  'set_to_selected_tags': '選択したタグに設定',
  'add_selected_tags': '選択したタグを追加',
  'remove_selected_tags': '選択したタグを削除',
  'clear_all_tags': 'すべてのタグをクリア',
  'Operation': '操作',
  'Tags': 'タグ',
  'Duration': '期間',
  'user_group_permission': 'ユーザーグループ権限',
  'device_group_permission': 'デバイスグループ権限',
  // ユーザー権限 - グローバルタイプ
  'Enable/Disable': '有効/無効',
  'Assign to User': 'ユーザーに割り当て',
  'Edit Info': '情報編集',
  'Edit Email': 'メール編集',
  'Edit Password': 'パスワード編集',
  'Edit Note': 'メモ編集',
  'Display Name': '表示名',
  'Edit Display Name': '表示名を編集',
  'Manage 2FA': '2FA管理',
  'Force Logout': '強制ログアウト',
  'permission_column_header_tooltip': 'すべての編集権限は表示権限を含みます。',
  'user_column_header_tooltip': '非管理者ユーザーは管理者アカウントを操作できません。',
  'create_role': '役割作成',
  'delete_role': '役割削除',
  'update_role': '役割更新',
  'add_users_to_role': '役割にユーザーを追加',
  'remove_users_from_role': '役割からユーザーを削除',
  'Role Name': '役割名',
  'Role name': '役割名',
  'Optional note': 'オプションのメモ',
  'Create Role': '役割作成',
  'Edit Role': '役割編集',
  'Overview': '概要',
  'Role List': '役割一覧',
  'Permissions': '権限',
  'User Count': 'ユーザー数',
  'Users': 'ユーザー',
  'Devices': 'デバイス',
  'User Groups': 'ユーザーグループ',
  'Device Groups': 'デバイスグループ',
  'Logs': 'セキュリティ監査',
  'Strategies': '戦略',
  'Custom Clients': 'カスタムクライアント',
  'View': '表示',
  'admin_not_restricted_by_roles': '管理者は管理者役割に制限されませんが、管理者役割を管理者に割り当てることができます。',
  'Roles': '役割',
  'Selected permissions': '選択された権限',
  'Auto-add recommended permissions': '推奨される権限を自動的に追加',
  'Groups': 'グループ',
  'Global': 'グローバル',
  'Individual': '個別',
  'Group Scoped': 'グループスコープ',
  'Scope': 'スコープ',
  'Unassigned devices': '未割り当てデバイス',
  'Update Group': 'グループ更新',
  'Update Strategy': '戦略更新',
  'View Devices': 'デバイス表示',
  'View Users': 'ユーザー表示',
  'View Device Groups': 'デバイスグループ表示',
  'Edit Devices': 'デバイス編集',
  'Edit Users': 'ユーザー編集',
  'Edit Device Groups': 'デバイスグループ編集',

  // ユーザー権限 - グローバルタイプ
  'view_users_permission_description_global': 'すべてのユーザーのリスト情報を読み取ります。',
  'user_create_permission_description_global': '非管理者ユーザーを直接作成します。',
  'user_invite_permission_description_global': 'メールでユーザーを招待します。',
  'user_delete_permission_description_global': '非管理者ユーザーを削除します。ユーザーは削除前に無効にする必要があります。',
  'user_enable_disable_permission_description_global': '非管理者ユーザーを有効または無効にします。',
  'user_edit_email_permission_description_global': '非管理者ユーザーのメールを変更します。',
  'user_edit_password_permission_description_global': '非管理者ユーザーのパスワードを変更します。',
  'user_edit_note_permission_description_global': '非管理者ユーザーのメモを変更します。',
  'user_edit_display_name_permission_description_global': '非管理者ユーザーの表示名を変更します。',
  'user_manage_2fa_permission_description_global': '非管理者ユーザーのログイン認証を管理します。2FAの強制を有効/無効にしたり、2FA設定をリセットしたり、メール認証を無効にします。',
  'user_force_logout_permission_description_global': 'すべてのデバイスから非管理者ユーザーを強制的にログアウトさせます。',
  'user_change_group_permission_description_global': '任意の非管理者ユーザーのグループを変更する',
  'user_change_strategy_permission_description_global': '任意の非管理者ユーザーのストラテジーを変更する',
  'user_change_control_role_permission_description_global': '任意の非管理者ユーザーのコントロールロールを変更する',

  // ユーザー権限 - グループタイプ
  'view_users_permission_description_group_scoped': '選択したユーザーグループ内のユーザーのリスト情報を読み取ります。',
  'user_create_permission_description_group_scoped': '選択したユーザーグループ内で非管理者ユーザーを作成します。',
  'user_invite_permission_description_group_scoped': '選択したユーザーグループ内でメールでユーザーを招待します。',
  'user_delete_permission_description_group_scoped': '選択したユーザーグループ内で非管理者ユーザーを削除します。ユーザーは削除前に無効にする必要があります。',
  'user_enable_disable_permission_description_group_scoped': '選択したユーザーグループ内の非管理者ユーザーを有効または無効にします。',
  'user_edit_email_permission_description_group_scoped': '選択したユーザーグループ内の非管理者ユーザーのメールを変更します。',
  'user_edit_password_permission_description_group_scoped': '選択したユーザーグループ内の非管理者ユーザーのパスワードを変更します。',
  'user_edit_note_permission_description_group_scoped': '選択したユーザーグループ内の非管理者ユーザーのメモを変更します。',
  'user_edit_display_name_permission_description_group_scoped': '選択したユーザーグループ内の非管理者ユーザーの表示名を変更します。',
  'user_manage_2fa_permission_description_group_scoped': '選択したユーザーグループ内で非管理者ユーザーのログイン認証を管理します。2FAの強制を有効/無効にしたり、2FA設定をリセットしたり、メール認証を無効にします。',
  'user_force_logout_permission_description_group_scoped': '選択したユーザーグループ内の非管理者ユーザーをすべてのデバイスから強制的にログアウトさせます。',
  'user_change_strategy_permission_description_group_scoped': '選択したユーザーグループ内の非管理者ユーザーのストラテジーを変更します。',
  'user_change_control_role_permission_description_group_scoped': '選択したユーザーグループ内の非管理者ユーザーのコントロールロールを変更します。',

  // デバイス権限 - グローバルタイプ
  'view_devices_permission_description_global': 'すべてのデバイスのリスト情報を読み取ります。',
  'device_enable_disable_permission_description_global': 'すべてのデバイスを有効または無効にします。',
  'device_delete_permission_description_global': 'すべてのデバイスを削除します。デバイスは削除前に無効にする必要があります。',
  'device_edit_info_permission_description_global': 'すべてのデバイスの名前、デバイスのユーザー名（デバイスのシステムユーザー名、RustDeskユーザー名ではない）およびメモを編集します。',
  'device_assign_to_user_permission_description_global': 'すべてのデバイスを任意のユーザーに割り当てます。',
  'device_change_group_permission_description_global': '任意のデバイスのグループを変更する',
  'device_change_strategy_permission_description_global': '任意のデバイスの戦略を変更する',

  // デバイス権限 - グループタイプ
  'view_devices_permission_description_group_scoped': '現在の役割が管理しているデバイスのリスト情報を読み取ります。',
  'device_enable_disable_permission_description_group_scoped': '現在の役割が管理しているデバイスを有効または無効にします。',
  'device_delete_permission_description_group_scoped': '現在の役割が管理しているデバイスを削除します。デバイスは削除前に無効にする必要があります。',
  'device_edit_info_permission_description_group_scoped': '現在の役割が管理しているデバイスの名前、デバイスのユーザー名（デバイスのシステムユーザー名、RustDeskユーザー名ではない）およびメモを編集します。',
  'device_change_strategy_permission_description_group_scoped': '現在の役割が管理しているデバイスの被制御ストラテジーを変更します。',

  // デバイス権限 - 個別タイプ
  'view_devices_permission_description_individual': 'ユーザーのデバイスリスト情報を読み取ります。',
  'device_enable_disable_permission_description_individual': 'ユーザーのデバイスを有効または無効にします。',
  'device_delete_permission_description_individual': 'ユーザーのデバイスを削除します。デバイスは削除前に無効にする必要があります。',
  'device_edit_info_permission_description_individual': 'ユーザーのデバイスの名前、デバイスのユーザー名（デバイスのシステムユーザー名、RustDeskユーザー名ではない）およびメモを編集します。',
  'device_change_strategy_permission_description_individual': 'ユーザーのデバイスの被制御ストラテジーを変更します。',

  // ユーザーグループ権限 - グローバルタイプ
  'view_user_groups_permission_description_global': 'すべてのユーザーグループのリスト情報を読み取ります。『ユーザー表示』権限を持っていれば、グループメンバーを表示できます。『ユーザーグループ更新』権限を持っていれば、ここでユーザーグループを一括更新できます。',
  'edit_user_groups_permission_description_global': 'ユーザーグループの作成、編集、削除を行います。グループメンバーの更新は含みません。',

  // デバイスグループ権限 - グローバルタイプ
  'view_device_groups_permission_description_global': 'すべてのデバイスグループのリスト情報を読み取ります。『デバイス表示』権限を持っていれば、グループメンバーを表示できます。『デバイスグループ更新』権限を持っていれば、ここでデバイスグループを一括更新できます。',
  'edit_device_groups_permission_description_global': 'デバイスグループの作成、編集、削除を行います。グループメンバーの更新は含みません。戦略更新権限を含みます。',
  'device_group_change_strategy_permission_description_global': '任意のデバイスグループの戦略を変更する',

  // 監査ログの権限 - グローバルタイプ
  'view_audits_permission_description_global': 'すべてのログを読み取ります。ノートを編集できます。「管理者のみがログにアクセスできる」オプションが有効な場合でもアクセスできます。',
  'edit_audits_permission_description_global': '任意のアクティブな接続を切断できます。',

  // 監査ログの権限 - 個別タイプ
  'view_audits_permission_description_individual': '個人のログを読み取ります。接続ログでは、個人のログには、現在そのユーザーに割り当てられているデバイスが被制御側または操作側のデバイスとして記録されたログ、およびそのユーザーが実際の操作ユーザーであるログが含まれます。ノートを編集できます。「管理者のみがログにアクセスできる」オプションが有効な場合でもアクセスできます。',
  'edit_audits_permission_description_individual': '個人のアクティブな接続を切断できます。',

  // ストラテジーの権限 - グローバルタイプ
  'view_strategies_permission_description_global': '任意のストラテジーを読み取ります。「ユーザーの表示」「デバイスの表示」「デバイスグループの表示」権限があれば、ユーザー、デバイス、デバイスグループのストラテジーを読み取れます。「ユーザーのストラテジー更新」「デバイスのストラテジー更新」「デバイスグループのストラテジー更新」権限があれば、ここで対応するストラテジーを一括更新できます。',
  'edit_strategies_permission_description_global': 'ストラテジーの作成、編集、削除を行います。ユーザー、デバイス、デバイスグループのストラテジーの更新は含みません。',

  // コントロールロールの権限 - グローバルタイプ
  'view_control_roles_permission_description_global': '任意のコントロールロールを読み取ります。「ユーザーの表示」権限があれば、ユーザーのコントロールロールを読み取れます。「ユーザーのコントロールロール更新」権限があれば、ここで対応するコントロールロールを一括更新できます。',
  'edit_control_roles_permission_description_global': 'コントロールロールの作成、編集、削除を行います。ユーザーのコントロールロールの更新は含みません。',

  // カスタムクライアントの権限
  'view_custom_clients_permission_description': 'カスタムクライアントのリストを読み取ります。コンパイル済みのカスタムクライアントをダウンロードできます。カスタムクライアントの詳細な設定は読み取れません。',
  'edit_custom_clients_permission_description': 'カスタムクライアントの作成、編集、削除を行います。',

  'global_type_description': 'システム全体のすべてのユーザー、デバイス、およびその他のリソースを管理するためのものです。',
  'individual_type_description': '割り当てられたユーザーのデバイスおよびログを管理するためのものです。',
  'group_scoped_type_description': '特定のユーザーグループ内のユーザーや、ユーザーに割り当てられたデバイスまたは特定のデバイスグループに所属するデバイスを管理するためのものです。',

  'user_groups_scope_description': '選択したユーザーグループ内のユーザーおよび、それらのユーザーに割り当てられたデバイスを管理します。',
  'device_groups_scope_description': '選択したデバイスグループ内のデバイスを管理します。',
  'unassigned_devices_scope_description': '未割り当てのデバイスを管理します（ユーザーやデバイスグループに割り当てられていないデバイス）。',

  'sync_device_name_with_hostname': 'デバイス名をコンピューターのホスト名と同期する',
  'allow_device_name_change_tip': '有効にすると、デバイス名はコンピューターのホスト名と同期されます。手動の変更（Web コンソール、CLI、API）は、クライアントまたはサービスの再起動後に上書きされる場合があります。',

  'Keyboard/Mouse': 'キーボード/マウス',
  'Remote Printer': 'リモートプリンター',
  'Clipboard': 'クリップボード',
  'Audio': 'オーディオ',
  'Camera': 'カメラ',
  'TCP Tunnel': 'TCPトンネル',
  'Remote Restart': 'リモート再起動',
  'Recording Session': '録画セッション',
  'Block User Input': 'ユーザー入力ブロック',
  'Remote Configuration Modification': 'リモート設定変更',
  'Control Role': 'コントロールロール',
  'Control Roles': 'コントロールロール',
  'Admin Roles': '管理者ロール',
  'create_control_role': 'コントロールロール作成',
  'update_control_role': 'コントロールロール更新',
  'delete_control_role': 'コントロールロール削除',
  'assign_users_to_control_role': 'コントロールロールにユーザーを割り当て',
  'remove_users_from_control_role': 'コントロールロールからユーザーを削除',
  'create_admin_role': '管理者ロール作成',
  'delete_admin_role': '管理者ロール削除',
  'update_admin_role': '管理者ロール更新',
  'add_users_to_admin_role': '管理者ロールにユーザーを追加',
  'remove_users_from_admin_role': '管理者ロールからユーザーを削除',
  'Admin Role': '管理者ロール',
  'Administrator': '管理者',
  'Update Control Role': 'コントロールロール更新',
  'not_logged_control_role_description': '制御側がログインしていない場合に適用されます。',
  'default_control_role_description': '特定の制御ロールが割り当てられていないユーザーに適用されます。',
  'control_role_not_set': 'クライアント設定を使用',
  'control_role_enable': '有効',
  'control_role_disable': '無効',
  'Remove': '削除',
  'Admin Role Permission': '管理者ロール権限',
  'Control Role Permission': 'コントロールロール権限',
  'Click to view users': 'ユーザーを表示',
  'Click to assign users': 'ユーザーを割り当て',
  'Assign Users': 'ユーザーを割り当て',
  'Added successfully': '追加に成功しました',
  'Adding failed, please try again!': '追加に失敗しました。もう一度お試しください。',
  'Update is successful': '更新に成功しました',
  'Update failed, please try again!': '更新に失敗しました。もう一度お試しください。',
  'Deletion is successful': '削除に成功しました',
  'Deletion failed, please try again!': '削除に失敗しました。もう一度お試しください。',
  'Allow': '許可',
  'Disallow': '禁止',
  'Allowed': '許可済み',
  'Disallowed': '禁止済み',
  'Allow connections within group': 'グループ内の接続を許可',
  'Allow connections to other groups': '他のグループへの接続を許可',
  'Allow connections from other groups': '他のグループからの接続を許可',
  'Allow connections from user groups': 'ユーザーグループからの接続を許可',
  'Allow connections from users': 'ユーザーからの接続を許可',
  'user groups': 'ユーザーグループ',
  'users': 'ユーザー',
  'other groups': '他のグループ',
  'Select a group': 'グループを選択',
  'Select a user': 'ユーザーを選択',
  'new version available': '新しいバージョンが利用可能です',
  'Config & QR code && Windows EXE': '設定・QR コード・Windows EXE',
  'Server': 'サーバー',
  'API': 'API',
};
